import { Button } from "../components/Button";
import { TrustCallout } from "../components/TrustCallout";
import { VerifyStepList } from "../components/VerifyStepList";
import { useFlow } from "../flow/FlowContext";
import { PHOTO_MAX, PHOTO_MIN } from "../flow/steps";
import { useT } from "../i18n";

export function VerifyIntroScreen() {
  const { next } = useFlow();
  const t = useT();

  return (
    <>
      <div
        className="screen-enter"
        style={{ flex: 1, display: "flex", flexDirection: "column", gap: 20 }}
      >
        <header className="screen-head">
          <div className="screen-head__eyebrow">{t("verify.intro.eyebrow")}</div>
          <h1 className="screen-head__title">{t("verify.intro.title")}</h1>
          <p className="screen-head__text">
            {t("verify.intro.text", { min: PHOTO_MIN, max: PHOTO_MAX })}
          </p>
        </header>
        <VerifyStepList
          statuses={{
            id: "active",
            video: "pending",
            photos: "pending",
            review: "pending",
          }}
        />
        <TrustCallout title={t("verify.intro.whyTitle")}>
          {t("verify.intro.whyBody")}
        </TrustCallout>
      </div>
      <div className="shell__footer" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Button onClick={next}>{t("verify.intro.start")}</Button>
      </div>
    </>
  );
}
